(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-card-page"]) return;
  try {
    
  $(document).ready(function () {
    $('.gift__tab-js').on('click', function () {
      $('.gift__tab-js').removeClass('active-green-link');
      $(this).addClass('active-green-link');
      let giftTab = $(this).data('gift-tab');
      $(`.gift__content-js`).addClass('d-none');
      $(`.gift__content-js[data-gift-content="${giftTab}"]`).removeClass('d-none');
    });
  });

  $(document).ready(function () {
    $('.amount-item-js').on('click', function () {
      $('.amount-item-js').removeClass('active');
      $(this).addClass('active');
      // $('.fc--input-enter_amt-js').val($(this).data('amount'));
      $('.gift_card-hidden-js').val($(this).data('variant-id'));
    });

    // $('.fc--input-enter_amt-js').on('keyup', function () {
    //   $('.amount-item-js').removeClass('active');
    // });
    function initialLoad() {
      let urlVariants = getVariantFromURL();
      if (urlVariants !== null) {
        $('.gift_card-hidden-js').val(urlVariants);
        $('.amount-item-js').removeClass('active');
        $('.amount-item-js').each(function (_, item) {
          if (Number($(item).data('variant-id')) === Number(urlVariants)) {
            $(item).addClass('active');
          }
        });
      }
    }

    function getVariantFromURL() {
      // Get the current URL
      const url = window.location.href;
      // Create a URL object
      const urlObj = new URL(url);
      // Get the value of the 'variant' query parameter
      const variant = urlObj.searchParams.get('variant');
      return variant;
    }

    initialLoad();

    $('.fc--textarea-js').on('keyup', function () {
      let maxLength = 200;
      let currentLength = $(this).val().length;
      let remaining = maxLength - currentLength;

      // Update the character count display
      $('.char-count').text(remaining);

      // Prevent typing beyond 200 characters
      if (currentLength > maxLength) {
        $(this).val($(this).val().substring(0, maxLength));
        $('.char-count').text(0);
      }
    });

    const $recipientEmail = $('.form__control-email-js');
    const $confirmEmail = $('.form__control-confirm_email-js');
    const $errorMessage = $('.form__control-error-js');
    const $submitButton = $('.fc--submit-js');

    // Function to validate email fields
    function validateEmails() {
      if ($recipientEmail.val() && $confirmEmail.val() && $recipientEmail.val() !== $confirmEmail.val()) {
        $errorMessage.removeClass('d-none');
        $submitButton.addClass('disabled_btn').prop('disabled', true);
      } else {
        $errorMessage.addClass('d-none');
        $submitButton.removeClass('disabled_btn').prop('disabled', false);
      }
    }

    // Add event listeners for real-time validation
    $recipientEmail.on('input', validateEmails);
    $confirmEmail.on('input', validateEmails);

    function hideAddToCartWhenItTouchFooter() {
      if ($(window).width() <= 767) {
        const footerTop = Math.floor($('.footer').offset().top);
        const addToCartTopPosition = Math.floor($('.form__control-btn-js').offset().top);

        if (addToCartTopPosition >= footerTop - 100) {
          $('.form__control-btn-js').addClass('active');
        } else {
          $('.form__control-btn-js').removeClass('active');
        }
      } else {
        $('.form__control-btn-js').removeClass('active');
      }
    }

    hideAddToCartWhenItTouchFooter();

    $(window).on('scroll', function () {
      hideAddToCartWhenItTouchFooter();
    });
    $(window).on('resize', function () {
      hideAddToCartWhenItTouchFooter();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    


  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    // setTimeout(() => {
    //   settingHeight();
    // }, 6000);
    // settingHeight();
    // function settingHeight() {
    //   let modalBodyHeight = $('.modal-body').height();
    //   let modalContentHeight = $('.modal-content').height();
    //   const newsLetterHeaderHeight = $('.rm-newsletter-upper').height();
    //   const newLetterLowerHeight = modalBodyHeight;
    //   if ($(window).width() <= 1440) {
    //     $('#newsletter-modal .modal-content').css('height', `auto`);
    //   } else {
    //     $('#newsletter-modal .modal-content').css('height', `auto`);
    //   }
    // }
    // $(window).on('resize', settingHeight);
  });

  document.getElementById('newsletter-popup-form').addEventListener('submit', function (e) {
    e.preventDefault();
    // console.log('form active');

    let formMessageDisplay = {
      signup_msg: 'Thank you for signing up!',
      subscribe_msg: 'Thank you! You are already subscribed.',
      error_msg: 'Sorry, there was an error. Please try again.',
    };

    let email = document.getElementById('contactFormEmail').value;
    let formMessage = document.querySelector('.form-message-display-popup-js');
    let formMessageContainer = document.querySelector('.rm-form-success-popup-js');
    let formLoaderCont = document.querySelector('.form-submit-container-popup-js');
    let formContainer = document.querySelector('#newsletter-popup-form');
    // console.log('Email:', email);

    // Show the loader
    formLoaderCont.classList.add('form__loader--active');

    // Shopify specific AJAX call
    let xhr = new XMLHttpRequest();
    let url = '/contact';
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        console.log('inside xhr');

        // Hide the loader when the request is complete
        formLoaderCont.classList.remove('form__loader--active');

        // form will hide and message will display
        formContainer.classList.add('d-none');

        if (xhr.status === 200) {
          localStorage.setItem('isNewsLetterSubscribe', 'true');
          formMessage.innerHTML = formMessageDisplay['signup_msg'];
          formMessageContainer.classList.remove('d-none');
        } else {
          formMessage.style.color = 'red';
          formMessage.innerHTML = formMessageDisplay['error_msg'];
          formMessageContainer.classList.remove('d-none');
        }
      }
    };

    xhr.send('form_type=customer&contact[email]=' + encodeURIComponent(email));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    // Get the content of the shipping_return-content-js div
    const shippingReturnsContent = $('.shipping_return-content-js').html();

    // Get the content of the assistance-content-js div
    const assistanceContent = $('.assistance-content-js').html();

    // Set content into respective elements
    if (shippingReturnsContent) {
      $('.content-tab-shipping_returns-js').html(shippingReturnsContent);
    }

    if (assistanceContent) {
      $('.content-tab-assistance-js').html(assistanceContent);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
